import Box from '@mui/material/Box';
import { styled } from '@mui/material/styles';

export const StArticleCarouselRoot = styled(Box)(({ theme }) => ({
  backgroundColor: theme.palette.white.main,
  maxWidth: '1365px',
  width: '100%',
  marginInline: 'auto',

  [theme.breakpoints.up(1024)]: {
    // Force each slide to span the carousel so arrows sit at the outer edges
    '& .MuiStack-root': {
      width: '100% !important',
      maxWidth: '100% !important',
      marginLeft: '0 !important',
      marginRight: '0 !important',
      display: 'flex !important',
      flexDirection: 'row',
      flexWrap: 'nowrap',
      justifyContent: 'center',
      alignItems: 'stretch',
      gap: theme.spacing(2),
      boxSizing: 'border-box',
      paddingInline: '56px',
    },

    '& .MuiStack-root > .MuiGrid-root': {
      flex: '1 1 0',
      maxWidth: '355px',
      width: 'auto',
      minWidth: 0,
      margin: theme.spacing(0.5),
    },

    '& .ui-article-card': {
      width: '100%',
      minWidth: '0 !important',
      maxWidth: '355px',
      margin: '0 !important',
      marginInline: '0 !important',
    },

    '& button[aria-label="Previous"], & button[aria-label="Next"]': {
      zIndex: 2,
    },
  },
}));

export const StArticleCarouselInner = styled(Box)(({ theme }) => ({
  display: 'flex',
  flexDirection: 'column',
  padding: '48px 41px',
  maxWidth: 'calc(100vw - 10px)',
  width: '100%',
  boxSizing: 'border-box',

  [theme.breakpoints.down(1024)]: {
    padding: '32px 24px',
  },
}));
